export const generateUniqueId = () => {
    return Math.random().toString(16).slice(2);
}

export const generateSecureUniqueId = () => {
    return Array.from(crypto.getRandomValues(new Uint8Array(16)))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');

}